var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 83 84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8 10.2 73.3.6 41.6 32.3 10.3 1.1.8 10.6 32 41.9 1.1 72.8l9.6 9.5 30.9-30.9 31.3 31.4 9.6-9.6-31.4-31.3z"
  })));
};
export default SvgClose;